export const findingSortMethod_Static = 'static';
export const findingSortMethod_Alphabet = 'alphabet';
export const findingSortMethod_Timestamp = 'timestamp';
export const findingSortMethod_BySystem = 'by-system';
export const findingSortMethods = [findingSortMethod_Static, findingSortMethod_Alphabet, findingSortMethod_Timestamp, findingSortMethod_BySystem];
//# sourceMappingURL=types.js.map